import { Pipe, PipeTransform } from '@angular/core';
import moment from 'jalali-moment';

@Pipe({
  name: 'shamsiDate'
})
export class ShamsiDatePipe implements PipeTransform {
  transform(value: string | Date, format: string = 'jYYYY/jMM/jDD'): string {
    if (!value) return '';
    return moment(value).locale('fa').format(format);
  }
}
